import styles from "../../css/dist/index.module.css";

export const shadowBorderClassName = `${styles["drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"]}`;

export const accentButtonClassName = `${styles["btn"]} ${styles["btn-accent"]} ${styles["h-16"]} ${styles["w-full"]}`;

export const excitingAccentButtonClassName = `${styles["btn"]} ${styles["btn-accent"]} ${styles["h-16"]} ${styles["w-full"]} ${styles["drop-shadow-accent"]} ${styles["hover:bg-accent"]} ${styles["hover:!border"]} ${styles["hover:!border-1"]} ${styles["border-accent"]} ${styles["transition-all"]} ${styles["duration-500"]} ${styles["hover:scale-[1.03]"]}`;

export const minorButtonClassName = `${styles["btn"]} ${styles["text-xs"]} ${styles["btn-neutral"]} ${styles["w-full"]} ${styles["font-normal"]} ${styles["!min-h-fit"]} ${styles["h-7"]} ${styles["opacity-80"]} ${styles["p-0"]}`;
